import PostTypeCheck from './PostTypeCheck';

export default PostTypeCheck;
